import React, { Component } from 'react'
import styled from 'styled-components'
import axios from 'axios'
import ReactTable from 'react-table'
import { API_URL } from '../constants'
import { PageWrapper, Checkbox, TextArea, TextField, FormikForm, FlexWrapper, Modal, Button } from '../components'
import { Formik, Field } from 'formik'
import 'react-table/react-table.css'
import moment from 'moment'
import { isEmpty, get } from 'lodash'
import { createGlobalStyle } from 'styled-components'

const GlobalStyle = createGlobalStyle`
  body>div{
    max-width:100% !important;
  }
`

const TableWrap = styled.div`
  position: relative;
  .ReactTable.-striped.-highlight {
    padding-bottom: 50px;
  }
  .rt-thead.-header {
    background: #078489;
    color: #fff;
  }
  .rt-td {
    white-space: normal !important;
  }
  .pagination-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #078489;
    color: #fff;
  }
  .ReactTable .-pagination .-btn[disabled] {
    color: #fff;
    opacity: 0.9;
  }
  .ReactTable .-pagination .-btn {
    color: #fff;
  }
  .rt-tbody {
    /* max-height: calc(100vh - 93px); */
  }
`
class BugAutomation extends Component {
  state = { loader: false, bugData: [], msg: '', id: null, showModal: false, isLoading: false }
  componentDidMount() {
    this.getBugReport()
  }

  getBugReport = async () => {
    const query = {
      filter: {
        include: ['productTableMerged', 'user']
      }
    }
    try {
      const { data } = await axios.get(`${API_URL}/UserBugReports`, { params: { filter: query.filter } })
      this.setState({ bugData: data })
    } catch (error) {
      console.log(error)
    }
  }
  handleBugFixed = async (id, isFixed) => {
    try {
      await axios.patch(`${API_URL}/UserBugReports/${id}`, {
        isResolved: !isFixed
      })
      this.getBugReport()
    } catch (error) {
      console.log(error)
    }
  }

 /*  handleChangeClassification = async (id, text) => {
    try {
      await axios.patch(`${API_URL}/UserBugReports/${id}`, {
        classification: text
      })
      this.getBugReport()
    } catch (error) {
      console.log(error)
    }
  } */

  render() {
    const { bugData } = this.state
    return (
      <React.Fragment>
        <GlobalStyle />
        <PageWrapper viewPadding="0 20px" height="auto" modifyPadding="0 20px">
          <TableWrap>
            <ReactTable
              data={bugData}
              columns={[
                {
                  Header: 'Timestamp',
                  accessor: 'createdAt',
                  Cell: row =>
                    row.original.createdAt
                      ? moment(get(row.original, 'createdAt', '')).format('DD MMM YYYY HH:mm:ss')
                      : '',
                  width: 150
                },
                {
                  Header: 'ID',
                  accessor: 'id',
                  width: 50
                },
                {
                  Header: 'isResolved',
                  accessor: 'isResolved',
                  Cell: row => (
                    <Checkbox
                      circle={false}
                      checked={get(row.original, 'isResolved', true) === true}
                      onChange={() =>
                        this.handleBugFixed(get(row.original, 'id', 0), get(row.original, 'isResolved', true))
                      }
                    />
                  ),
                  width: 100
                },
                {
                  Header: 'UserId',
                  accessor: 'userId',
                  width: 70
                },
                {
                  Header: 'UserEmail',
                  Cell: row => get(row.original, 'user.email', ''),
                  width: 200
                },
                {
                  Header: 'issueDescription',
                  accessor: 'description',
                  width: 150
                },
                {
                  Header: 'issueClassification',
                  accessor: 'classification',
                  Cell: row => (
                    <React.Fragment>
                      <div>{get(row, 'original.classification', '')}</div>{' '}
                      <span
                        style={{ color: '#124b5f', textDecoration: 'underline' }}
                        onClick={() =>
                          this.setState({
                            showModal: true,
                            msg: get(row, 'original.classification', ''),
                            id: get(row, 'original.id', '')
                          })
                        }>
                        {' '}
                        Edit
                      </span>
                    </React.Fragment>
                  ),
                  width: 300
                },
                {
                  Header: 'Product',
                  accessor: 'productCode',
                  width: 200
                },
                {
                  Header: 'productName',
                  Cell: row => get(row.original, 'productTableMerged.productName', ''),
                  width: 150
                },
                {
                  Header: 'productCategory',
                  Cell: row => get(row.original, 'productTableMerged.productCategory', ''),
                  width: 150
                },
                {
                  Header: 'productType',
                  Cell: row => get(row.original, 'productTableMerged.productType', ''),
                  width: 150
                },
                {
                  Header: 'productDescription',
                  Cell: row => get(row.original, 'productTableMerged.productDescription', ''),
                  width: 300
                },
                {
                  Header: 'productImage',
                  Cell: row =>
                    isEmpty(get(row.original, 'productTableMerged.productImage', '')) ? (
                      <img src={require('../static/images/no-image.png')} height="100px" alt={'demo'} />
                    ) : (
                      <img
                        src={get(row.original, 'productTableMerged.productImage', '')}
                        height="100px"
                        alt={get(row.original, 'productTableMerged.productName', '')}
                      />
                    ),
                  width: 150
                },
                {
                  Header: 'ingredientList',
                  Cell: row => get(row.original, 'productTableMerged.ingredientList', ''),
                  width: 300
                },
                {
                  Header: 'allergyConflicts',
                  Cell: row => get(row.original, 'productTableMerged.allergyConflicts', ''),
                  width: 200
                },
                {
                  Header: 'dietConflicts',
                  Cell: row => get(row.original, 'productTableMerged.dietConflicts', ''),
                  width: 200
                },
                {
                  Header: 'Environment',
                  Cell: row => get(row.original, 'productTableMerged.environment', ''),
                  width: 100
                },
                {
                  Header: 'FoodSafety',
                  Cell: row => get(row.original, 'productTableMerged.foodSafety', ''),
                  width: 100
                },
                {
                  Header: 'Processing',
                  Cell: row => get(row.original, 'productTableMerged.processing', ''),
                  width: 100
                },
                {
                  Header: 'Nutrition',
                  Cell: row => get(row.original, 'productTableMerged.nutrition', ''),
                  width: 100
                },
                {
                  Header: 'totalGs',
                  Cell: row => get(row.original, 'productTableMerged.totalGs', ''),
                  width: 100
                }
              ]}
              defaultPageSize={50}
              // pageSize={5}
              minRows={0}
              resizable={false}
              className="-striped -highlight"
            />
          </TableWrap>
        </PageWrapper>
        <Modal
          title={'Edit Classification'}
          show={this.state.showModal}
          hide={!this.state.showModal}
          style={{ minHeight: 240 }}
          onClose={() => this.setState({ showModal: false })}>
          <FlexWrapper alignItems="center">
            <Formik
              enableReinitialize
              initialValues={{
                classification: get(this.state, 'msg', '')
              }}
              onSubmit={async val => {
                this.setState({ isLoading: true })
                await axios.patch(`${API_URL}/UserBugReports/${get(this.state, 'id', '')}`, {
                  classification: val.classification
                })
                this.getBugReport()
                this.setState({ isLoading: false, showModal: false, msg: '', id: null })
              }}
              render={formikBag => (
                <FormikForm>
                  <Field
                    name="classification"
                    render={({ field }) => (
                      <FlexWrapper height="100%">
                        <TextArea
                          {...field}
                          height="140px"
                          paddingTop="10px"
                          type="text"
                          placeholder="Message"
                          fontColor="#124b5f"
                          viewPadding="10px 14px 0"
                        />
                      </FlexWrapper>
                    )}
                  />
                  <Button
                    volume="filled"
                    type="submit"
                    label="Submit"
                    disabled={this.state.isLoading}
                    isLoading={this.state.isLoading}
                  />
                </FormikForm>
              )}
            />
          </FlexWrapper>
        </Modal>
      </React.Fragment>
    )
  }
}
export default BugAutomation



// WEBPACK FOOTER //
// ./src/pages/BugAutomation.js